function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import MUISnackbar from '@mui/material/Snackbar';
const SnackbarFRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MUISnackbar, _extends({}, props, {
  ref: ref
})));
export const Snackbar = props => /*#__PURE__*/React.createElement(SnackbarFRef, props);
export default Snackbar;